import { FocusEvent, KeyboardEvent, ReactNode, useCallback } from 'react';

import { format } from 'date-fns';
import { twMerge } from 'tailwind-merge';

import { Input } from '../../../Fields';

import { isDateStringValid } from './utils';

interface ListProps {
  readonly header?: string;
  readonly date: Date;
  readonly children?: ReactNode;
  readonly onChangeDate?: (date: Date) => void;
  readonly className?: string;
}

function List({ header, date, children, onChangeDate, className }: ListProps) {
  const classes = twMerge(className, 'flex flex-col');

  const updateValidDate = useCallback(
    (value: string) => {
      const _date = isDateStringValid(value);

      if (_date) {
        onChangeDate?.(_date);
      }
    },
    [onChangeDate],
  );

  const onKeyUpHandler = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.currentTarget.blur();
    }
  }, []);

  const onBlurHandler = useCallback(
    (e: FocusEvent<HTMLInputElement>) => {
      updateValidDate(e.currentTarget.value);
    },
    [updateValidDate],
  );

  return (
    <div className={classes}>
      <div className="flex flex-auto flex-row items-start">
        {header ? <h6 className="mr-5 w-16 text-base font-normal">{header}</h6> : null}
        <div className="flex flex-col">
          <Input
            key={date.toDateString()}
            defaultValue={format(date, 'dd/MM/yyyy')}
            onKeyUp={onKeyUpHandler}
            onBlur={onBlurHandler}
            className="mb-1"
          />
          {children}
        </div>
      </div>
    </div>
  );
}

export { List };
